export default {
    computed: {
        elementValueName: {
            get() {
                const _name = 'name'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'name'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        },
        elementValueArtnr: {
            get() {
                const _name = 'artnr'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'artnr'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        },
        elementValueLockid: {
            get() {
                const _name = 'lockid'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'lockid'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        },
        elementValueEnr: {
            get() {
                const _name = 'enr'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'enr'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        },
        elementValueNobnr: {
            get() {
                const _name = 'nobnr'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'nobnr'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        },
        elementValueInfo: {
            get() {
                const _name = 'info'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'info'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        },
        elementValueVariants: {
            get() {
                const _name = 'variants'
                return this.showOriginal ? this.form[_name] : this.form.translations[this.langcode][_name];
            },
            set(value) {
                const _name = 'variants'
                if (this.showOriginal) {
                    this.form[_name] = value;
                } else {
                    this.form.translations[this.langcode][_name] = value;
                }
            }
        }
    }
}